import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminHome from "./components/Admin/AdminHome";
import AdminProducts from "./components/Admin/AdminProducts";
import AdminOrders from "./components/Admin/AdminOrders";
import AdminCustomers from "./components/Admin/AdminCustomers";
import AdminAnalytics from "./components/Admin/AdminAnalytics";
import AdminSettings from "./components/Admin/AdminSettings";
import AdminDecoration from "./components/Admin/AdminDecoration";
import AdminContact from "./components/Admin/AdminContact";
import AdminLogin from "./components/Admin/AdminLogin";
import AdminTransactions from "./components/Admin/AdminTransactions";
import MaintenanceMode from "./components/Admin/MaintenanceMode";
import AdminReviewManage from "./components/Admin/AdminReviewManage";
import ComboManagement from "./components/Admin/ComboManagement";
import AdminAiPage from "./components/Admin/AdminAiPage";

const isAuthenticated = () => {
  const token = localStorage.getItem('admin_token');
  return token && token !== 'undefined' && token !== 'null' && token.trim() !== '';
};

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function AdminApp() {
  return (
    <div className="App">
      <Router>
        <ToastContainer />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={<ProtectedRoute><AdminHome /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/products" 
            element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/combo" 
            element={<ProtectedRoute><ComboManagement /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/orders" 
            element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/transactions" 
            element={<ProtectedRoute><AdminTransactions /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/maintanence" 
            element={<ProtectedRoute><MaintenanceMode /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/customers" 
            element={<ProtectedRoute><AdminCustomers /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/analytics" 
            element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/settings" 
            element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/media" 
            element={<ProtectedRoute><AdminDecoration /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/reviews" 
            element={<ProtectedRoute><AdminReviewManage /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/contactadmin" 
            element={<ProtectedRoute><AdminContact /></ProtectedRoute>} 
          />
          <Route 
            path="/admin/mashoai" 
            element={<ProtectedRoute><AdminAiPage /></ProtectedRoute>} 
          />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default AdminApp;